import type { ReactNode } from "react";
import {
  TGroupChatChannelMember,
  TGroupChatSendbirdUser,
} from "../../api/group_chat/get_channel";
import { TGroupChatHistoryMessage } from "../../api/group_chat/get_history";
import ST from "../../assets/styles/organisms/chatMessageHistory.module.scss";

// チャンネルの参加者名を取得
export const getChannelMemberName = (
  sendUser: TGroupChatChannelMember,
  sendbirdUsers: TGroupChatSendbirdUser[] | null,
  siteName: string | undefined,
): ReactNode => {
  if (!sendUser?.is_active || !sendUser.sender_type) {
    return null;
  }

  if (sendUser.sender_type === "member") {
    const name =
      sendbirdUsers?.find((u) => u.sendbird_user_id === sendUser.sendbird_user_id)
        ?.name ?? "名前なし";
    return (
      <>
        {name}
        <span className={ST.type_member}>会員</span>
      </>
    );
  }

  if (sendUser.sender_type === "user") {
    const name =
      sendbirdUsers?.find((u) => u.sendbird_user_id === sendUser.sendbird_user_id)
        ?.name ?? "名前なし";
    return (
      <>
        {name}
        <span className={ST.type_user}>ユーザー</span>
      </>
    );
  }

  if (sendUser.sender_type === "company") {
    return (
      <>
        {siteName ?? "名前なし"}
        <span className={ST.type_user}>ユーザー</span>
      </>
    );
  }

  return null;
};

// メッセージ一覧の送信者名を取得
export const getChannelMemberForMessage = (
  message: TGroupChatHistoryMessage,
  siteName: string | undefined,
): ReactNode => {
  if (message.sender_type === "member") {
    return (
      <>
        <span className={ST.sender_name}>
          {message.sender_name ?? "名前なし"}
        </span>
        <span className={ST.type_member}>会員</span>
      </>
    );
  }
  if (message.sender_type === "user") {
    return (
      <>
        <span className={ST.sender_name}>
          {message.sender_name ?? "名前なし"}
        </span>
        <span className={ST.type_user}>ユーザー</span>
      </>
    );
  }
  if (message.sender_type === "company") {
    return (
      <>
        <span className={ST.sender_name}>{siteName ?? "名前なし"}</span>
        <span className={ST.type_user}>ユーザー</span>
      </>
    );
  }
  return (
    <span className={ST.sender_name}>{message.sender_name ?? "名前なし"}</span>
  );
};
